var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.1614,
    cy: 30.6602,
    r: 30,
    fill: "#8DC63F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5296 18.4258H23.4702L30.4999 27.1763L37.5296 18.4258ZM45.1666 27.7163L39.0135 19.5116L32.4249 27.7163H45.1666ZM21.9864 19.5099L15.8333 27.7163H28.5749L21.9864 19.5099ZM29.8296 44.1432C30.0015 44.3348 30.2478 44.4393 30.4999 44.4393C30.752 44.4393 30.9957 44.3332 31.1685 44.1454L45.0864 29.5744H15.9115L29.8296 44.1432Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumLarge);
export default __webpack_public_path__ + "static/media/premium-large.cb0730df3155b8d1a81b8f5eda2f6457.svg";
export { ForwardRef as ReactComponent };